/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';

const useLocalStorage = (key = '', initialValue = []) => {
  const [state, setState] = useState(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });

  const setLocalStorageState = newState => {
    try {
      const newStateValue = typeof newState === 'function' ? newState(state) : newState;
      setState(newStateValue);
      window.localStorage.setItem(key, JSON.stringify(newStateValue));
    } catch (error) {
      console.error(`Unable to store new value for ${key} in localStorage.`);
    }
  };

  useEffect(() => {
    //console.log("x");
  }, []);

  return [state, setLocalStorageState];
};

export default useLocalStorage;
